import { createFileRoute } from "@tanstack/react-router";
import { Check, Instagram } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  CommunityPage,
  CreatorCard,
  OWNER_INSTAGRAM_URL,
} from "@/components/community/community-ui";
import { breadcrumbScript, seo } from "@/lib/seo";

const DESCRIPTION = "Connect directly with Aryan Singh, founder and owner of The Quantum Minds.";

export const Route = createFileRoute("/community/owner")({
  head: () => ({
    ...seo({ title: "Owner & Support — The Quantum Minds", description: DESCRIPTION, path: "/community/owner" }),
    scripts: [breadcrumbScript([
      { name: "Home", path: "/" },
      { name: "Our Community", path: "/community" },
      { name: "Owner & Support", path: "/community/owner" },
    ])],
  }),
  component: OwnerSupportPage,
});

const POINTS = [
  "Smart tools & resources",
  "Structured preparation",
  "Student-focused platform",
  "Constantly evolving",
];

function OwnerSupportPage() {
  return (
    <CommunityPage title="Owner & Support" backTo="/community">
      <CreatorCard compact />
      <section className="glass rounded-3xl p-5 sm:p-6">
        <h2 className="text-xs font-bold uppercase tracking-[0.18em] text-primary">Connect Directly</h2>
        <p className="mt-3 text-sm leading-6 text-muted-foreground">
          For support, feedback, collaborations or important queries.
        </p>
        <Button asChild size="lg" className="mt-5 w-full">
          <a href={OWNER_INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
            <Instagram /> Message on Instagram
          </a>
        </Button>
      </section>
      <section className="glass rounded-3xl p-5 sm:p-6">
        <h2 className="text-xs font-bold uppercase tracking-[0.18em] text-primary">
          About The Quantum Minds
        </h2>
        <p className="mt-3 text-sm leading-6 text-muted-foreground">
          The Quantum Minds is an all-in-one JEE &amp; NEET preparation platform focused on smart
          preparation, structured practice and useful study tools.
        </p>
        <ul className="mt-5 grid gap-3 sm:grid-cols-2">
          {POINTS.map((point) => (
            <li key={point} className="flex items-center gap-3 text-sm text-foreground">
              <span className="grid size-6 shrink-0 place-items-center rounded-full bg-success/12 text-success">
                <Check className="size-3.5" />
              </span>
              {point}
            </li>
          ))}
        </ul>
      </section>
    </CommunityPage>
  );
}
